import { cn } from '@/lib/utils';
import React from 'react';

const SEGMENT_COLORS = {
  low: '#FD6B62',
  mid: '#FDB462',
  high: '#1CA388'
};

export function PerformanceBarRow({ label, average, low, mid, high, showAverage = true }) {
  const segments = [
    { key: 'low', value: low },
    { key: 'mid', value: mid },
    { key: 'high', value: high }
  ].filter(segment => segment.value > 0);

  return (
    <div className="flex w-full items-center gap-[9px]">
      <div className="w-[126px] shrink-0">
        <p className={cn('mb-0 text-sm', showAverage ? 'font-bold text-primary-dark' : 'text-neutral-darker')}>{label}</p>
        {showAverage && <p className="mb-0 text-xs text-neutral-darker">Média {average}%</p>}
      </div>
      <div className="flex h-8 flex-1 overflow-hidden rounded-full">
        {segments.map(segment => (
          <div
            key={segment.key}
            className="flex items-center justify-center whitespace-nowrap text-xs font-bold text-white"
            style={{ width: `${segment.value}%`, backgroundColor: SEGMENT_COLORS[segment.key] }}
          >
            {segment.value}%
          </div>
        ))}
      </div>
    </div>
  );
}

export function PerformanceLegend() {
  return (
    <div className="flex flex-wrap items-center justify-center gap-4 pt-4">
      <span className="flex items-center gap-1 text-xs text-neutral-darker">
        <span
          className="size-3 rounded-full"
          style={{ backgroundColor: SEGMENT_COLORS.low }}
        />
        Baixo (0–40%)
      </span>
      <span className="flex items-center gap-1 text-xs text-neutral-darker">
        <span
          className="size-3 rounded-full"
          style={{ backgroundColor: SEGMENT_COLORS.mid }}
        />
        Médio (40–70%)
      </span>
      <span className="flex items-center gap-1 text-xs text-neutral-darker">
        <span
          className="size-3 rounded-full"
          style={{ backgroundColor: SEGMENT_COLORS.high }}
        />
        Alto (70–100%)
      </span>
    </div>
  );
}
